"use client";

import { createContext, useContext, useState, type ReactNode } from "react";

type OmniboxState = "idle" | "active" | "processing";

interface OmniboxStateContextType {
  state: OmniboxState;
  setState: (state: OmniboxState) => void;
}

const OmniboxStateContext = createContext<OmniboxStateContextType | undefined>(undefined);

export function OmniboxStateProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<OmniboxState>("idle");

  return <OmniboxStateContext.Provider value={{ state, setState }}>{children}</OmniboxStateContext.Provider>;
}

export function useOmniboxState() {
  const context = useContext(OmniboxStateContext);
  if (!context) {
    throw new Error("useOmniboxState must be used within OmniboxStateProvider");
  }
  return context;
}

export function useOmniboxStateOptional() {
  return useContext(OmniboxStateContext);
}
